import { WorkloadOptimizationSummaryResponse } from '@cast/types';

export type AutoscalerImpactData = {
  adoptionPercentage: number;
  cpuCoresDifference: number;
  totalCount: number;
  costWorkloads: number;
  performanceWorkloads: number;
  optimizedCount: number;
  nonOptimizedCount: number;
};

export const normalizeAutoscalerImpact = (
  data: WorkloadOptimizationSummaryResponse
): AutoscalerImpactData => {
  const {
    totalCount,
    optimizedCount,
    cpuCoresDifference,
    vpaOptimizedCount,
    hpaOptimizedCount,
  } = data;

  return {
    totalCount,
    optimizedCount,
    nonOptimizedCount: totalCount - optimizedCount,
    adoptionPercentage: totalCount ? (optimizedCount / totalCount) * 100 : 0,
    cpuCoresDifference,
    costWorkloads: vpaOptimizedCount,
    performanceWorkloads: hpaOptimizedCount,
  };
};
